import { render, staticRenderFns } from "./FlagTitle.vue?vue&type=template&id=a50ad5de&scoped=true&"
import script from "./FlagTitle.vue?vue&type=script&lang=js&"
export * from "./FlagTitle.vue?vue&type=script&lang=js&"
import style0 from "./FlagTitle.vue?vue&type=style&index=0&id=a50ad5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50ad5de",
  null
  
)

export default component.exports